/**
 * Charge catégories et pays TheMealDB au montage
 */

import { useState, useEffect } from "react";

export function useFridgeData() {
  const [categories, setCategories] = useState([]);
  const [countries, setCountries] = useState([]);

  useEffect(() => {
    let cancelled = false;
    Promise.all([
      fetch("https://www.themealdb.com/api/json/v1/1/categories.php")
        .then((r) => r.json())
        .then((data) => (cancelled ? [] : data.categories || [])),
      fetch("https://www.themealdb.com/api/json/v1/1/list.php?a=list")
        .then((r) => r.json())
        .then((data) =>
          cancelled
            ? []
            : (data.meals || []).filter((c) => c.strArea !== "Thai"),
        ),
    ]).then(([cats, areas]) => {
      if (!cancelled) {
        setCategories(cats);
        setCountries(areas);
      }
    });
    return () => {
      cancelled = true;
    };
  }, []);

  return { categories, countries };
}
